<template>
  <l-container>
    <l-container-title slot="toolbar" text="Historical data" icon="chart-bar" color="bg-pastel-red" />
    <div v-show="true" class="w-full flex flex-col">
      <div class="flex">

        <!-- FROMTIME -->
        <div class="mr-4">
          <vue-ctk-date-time-picker
            v-model="dateRangeFrom"
            :no-value-to-custom-elem="true"
            input-size="sm"
            format="YYYY-MM-DD HH:mm"
            formatted="YYYY-MM-DD HH:mm"
            label="Select from time"
            button-now-translation="Now"
            color="#7fa99b"
            :no-clear-button="true"
            :no-header="true"
          >
            <l-input v-model="dateRangeFrom" type="text" placeholder>
              <template slot="prefix">
                <font-awesome-icon icon="clock" class="text-base text-gray-500" />
              </template>
            </l-input>
          </vue-ctk-date-time-picker>
        </div>

        <!-- TOTIME -->
        <div class="mr-4">
          <vue-ctk-date-time-picker
            v-model="dateRangeTo"
            :no-value-to-custom-elem="true"
            input-size="sm"
            format="YYYY-MM-DD HH:mm"
            formatted="YYYY-MM-DD HH:mm"
            label="Select to time"
            button-now-translation="Now"
            color="#7fa99b"
            :no-clear-button="true"
            :no-header="true"
          >
            <l-input v-model="dateRangeTo" type="text" placeholder>
              <template slot="prefix">
                <font-awesome-icon icon="clock" class="text-base text-gray-500" />
              </template>
            </l-input>
          </vue-ctk-date-time-picker>
        </div>
      </div>

      <div class="flex mt-4 w-full">
        <div class="w-full">
          <l-select v-model="timeseriesSelection" class="text-xs" :data="timeseriesWithinDateRange" placeholder="Please select a timeserie" :multiple="true">
            <l-input v-model="q" placeholder="Search" type="search">
              <template slot="suffix">
                <font-awesome-icon icon="search" class="text-3xs text-gray-dark" />
              </template>
            </l-input>
            <l-option
              v-for="i in filteredTimeseries"
              :key="i.value"
              class="text-xs"
              :value="i.value"
              :label="i.label"
            />
          </l-select>
        </div>
      </div>
      <!-- OPTIONS -->
      <div class="flex mt-4">        
        <l-checkbox class="mr-4" v-model="onlyValidValues" label="Show only valid values"></l-checkbox>
        <l-checkbox class="mr-4" v-model="viewAsBar">View chart as <i><b>bar type</b></i></l-checkbox>
      </div>
      <div class="flex mt-4">        
        <l-button type="success" :disabled="timeseriesSelection == null || timeseriesSelection.length == 0" @click="onClick">View timeseries</l-button>
      </div>
    </div>
  </l-container>
</template>

<script>
import VueCtkDateTimePicker from "vue-ctk-date-time-picker";
import "vue-ctk-date-time-picker/dist/vue-ctk-date-time-picker.css";
import * as moment from "moment";
import { HistoricalService } from "@/helpers/services/viewer/historical.service";
import { LSelect, LOption, LButton, LInput, LCheckbox } from "@/components/forms";
export default {
  name: "LLSelection",
  components: {
    LInput,
    LSelect,
    LOption,
    LButton,
    LCheckbox,
    VueCtkDateTimePicker
  },
  props: ["timeseries"],
  data() {
    return {
      q: "",      
      timeseriesSelection: null,
      dateRangeFrom: moment().add(-1, "months").format("YYYY-MM-DD"),
      dateRangeTo: moment().add(1, "days").format("YYYY-MM-DD"),
      onlyValidValues:true,
      viewAsBar:false
    };
  },
  computed: {
    filteredTimeseries() {
      return this.timeseriesWithinDateRange.filter(f => {
        return f.label.toUpperCase().indexOf(this.q.toUpperCase()) !== -1;
      });
    },
    timeseriesWithinDateRange() {
      return this.timeseries.filter(f => {
        if (!f.fromtime && !f.totime) return true;

        const from = moment(this.dateRangeFrom);
        const to = moment(this.dateRangeTo);
        const ts_from = moment(f.fromtime);
        const ts_to = moment(f.totime);
        const timeseriesWithinDateRange = ts_to.isAfter(from) && ts_from.isBefore(to);
        
        return timeseriesWithinDateRange;
      });
    }
  },
  methods: {
    onClick() {
      this.$emit("click", {
        timeseries: this.timeseriesSelection.map(p => p.value),
        from: this.dateRangeFrom,
        to: this.dateRangeTo,
        onlyValidValues: this.onlyValidValues,
        viewAsBar: this.viewAsBar
      });
    }
  }
};
</script>
